import monitorService from '@/services/monitor.service';
import { filterRulesMapped } from '@/tools/filterRules';
import { TRACK_STATUS_HEADERS } from './constants';

export default {
    name: "TrackStatusComponent",
    components: {},
    data() {
        return {
            tableDataKey: "unitId",
            tableHeaders: TRACK_STATUS_HEADERS,
            tableFilterRules: {},
            tableData: [],
            loading: false,
            unitIds: [],
            unitIdSelected: null,
            unitIdInteval: null
        };
    },
    async mounted() {
        this.loading = true;
        try {
            this.unitIds = await monitorService.getTrackStatusUnitIds();
            this.tableData.cleanAndUpdate([]);
            this.setTableFilterRules();
        } finally {
            this.loading = false;
        }
        this.unitIdInteval = setInterval(async () => {
            await this.getUnitIds();
        }, 30000);
    },
    beforeDestroy() {
        clearInterval(this.unitIdInteval);
    },
    methods: {
        async getUnitIds() {
            this.unitIds = await monitorService.getTrackStatusUnitIds();
        },
        async refreshTable() {
            try {
                this.loading = true;
                await this.updateTable();
            } finally {
                this.loading = false;
            }
        },
        async changeValue(value) {
            this.unitIdSelected = value;
            try {
                this.loading = true;
                await this.updateTable();
            } finally {
                this.loading = false;
            }
        },
        async updateTable() {
            if (this.unitIdSelected) {
                const data = await monitorService.getTrackStatusData(this.unitIdSelected);
                this.tableData.cleanAndUpdate(data);
            } else {
                this.tableData.cleanAndUpdate([]);
            }
        },
        setTableFilterRules() {
            this.tableFilterRules = {}
            this.tableHeaders.forEach(header => {
                this.tableFilterRules[header.value] = filterRulesMapped[header.filterType]
            })
        },
    }
};
